var React = require('react');

function Searchsss (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.3848 5.39122C2.5733 2.53736 5.35801 0.675143 8.44945 0.666886C11.7813 0.649341 14.7439 2.78349 15.7825 5.94936C16.8211 9.11523 15.6984 12.5896 13.0037 14.5491C10.3089 16.5087 6.65771 16.5057 3.96612 14.5419L1.56612 16.9419C1.3221 17.1856 0.926798 17.1856 0.682783 16.9419C0.439072 16.6979 0.439072 16.3026 0.682783 16.0586L3.00778 13.7336C0.836036 11.5334 0.196297 8.24508 1.3848 5.39122ZM2.49909 10.8077C3.49699 13.2124 5.8459 14.7786 8.44945 14.7752V14.7419C11.983 14.7374 14.8516 11.8837 14.8745 8.35022C14.8778 5.74667 13.3116 3.39776 10.9069 2.39986C8.50217 1.40197 5.73306 1.95185 3.89207 3.79284C2.05108 5.63383 1.5012 8.40294 2.49909 10.8077Z","fill":"#AAAAAA"}));
}

Searchsss.defaultProps = {"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none"};

module.exports = Searchsss;

Searchsss.default = Searchsss;
